import Label from 'Components/Label';
import { useEffect, useState } from 'react';
import moment from 'moment';
import Button from 'Components/Button';
import Paginador from 'Components/Paginador';
import ProgressBar from 'Components/ProgressBar';
import NotificacionesService from 'Services/Http/Notificaciones.service';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { setNotificacion } from '../../../../../redux/slices';

const ListarNotificacionesComponente = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otps, setOtps] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pageActive, setPageActive] = useState(0);
  useEffect(() => {
    getlastOtps();
  }, []);

  const getlastOtps = async (page) => {
    setLoader(true);
    setOtps([]);
    setPageActive(page);
    const response = await NotificacionesService.getCatalogoNotificacion({ page });
    createRows(response.data);
    setLoader(false);
  };

  const goTo = (url) => {
    navigate(url);
  };

  const goToDetalle = (item) => {
    dispatch(setNotificacion(item));
    const url = '/main/admin/notificaciones/lectura';
    goTo(url);
  };

  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'otps-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td className="px-6 py-4">{item.id}</td>
        <td className="px-6 py-4">{item.title}</td>
        <td className="px-3 py-4">{item.descripcion}</td>
        <td className="px-6 py-4">
          {item.tipo == 1 ? (
            <button className="w-full bg-red-100 text-red-500 p-2 rounded-lg" type="button">
              Urgente
            </button>
          ) : (
            ''
          )}
          {item.tipo == 2 ? (
            <button className="w-full bg-blue-500 text-white p-2 rounded-lg" type="button">
              Informativo
            </button>
          ) : (
            ''
          )}
          {item.tipo == 3 ? (
            <button className="w-full bg-gray-100 p-2 rounded-lg" type="button">
              General
            </button>
          ) : (
            ''
          )}
        </td>
        <td className="px-6 py-4">
          {moment(item.created_at).utc().format('DD/MM/YYYY hh:mm:ss a')}
        </td>
        <td className="px-6 py-4" onClick={() => goToDetalle(item)}>
          <FontAwesomeIcon icon={['fa', 'chevron-right']} />
        </td>
      </tr>
    ));
    setOtps(data);
  };
  const refresh = () => {
    getlastOtps(pageActive);
  };
  return (
    <>
      <Label text={'Lista de notificaciones'} />
      <div className="flex flex-col grid grid-cols-1 md:grid md:grid-flow-col md:grid-cols-2 md:flex-row gap-3 my-3 justify-stretch">
        <div className="flex order-2 md:order-1">
          <Button iconprefix={['fa', 'rotate']} onClick={() => refresh()} />
          <Button
            label={'Agregar notificacion'}
            color={'primary'}
            onClick={() => goTo('/main/admin/notificaciones/nueva')}
          />
        </div>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Titulo
              </th>
              <th scope="col" className="px-6 py-3">
                Descripcion
              </th>
              <th scope="col" className="px-6 py-3">
                Estatus
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha y hora de creacion
              </th>
              <th scope="col" className="px-6 py-3">
                Detalle
              </th>
            </tr>
          </thead>
          <tbody>{otps}</tbody>
          <tfoot>
            <tr>
              <td colSpan={8}>
                <Paginador onChange={getlastOtps} />
              </td>
            </tr>
          </tfoot>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </>
  );
};

export default ListarNotificacionesComponente;
